import { isSameDate, isEarlierDate, isLaterDate } from '../../generic-utils/dateUtils.esm.js';
import dateUtils from './dateUtils.esm.js';
var isDateWithinRange = function (selectionStart, selectionEnd, date) {
  return !!selectionStart && !!selectionEnd && isLaterDate(selectionStart, date) && isEarlierDate(selectionEnd, date);
};
var getSelectionType = function (_a) {
  var selectionStart = _a.selectionStart,
    selectionEnd = _a.selectionEnd,
    isSingleDateSelection = _a.isSingleDateSelection,
    day = _a.day,
    enableSameDayDateRange = _a.enableSameDayDateRange,
    unconfirmedSelectionEnd = _a.unconfirmedSelectionEnd;
  var dateString = day ? day.dateString : '';
  if (!dateString || !selectionStart && !selectionEnd && !unconfirmedSelectionEnd && !isSingleDateSelection || isSingleDateSelection && !selectionStart) {
    return 'Unselected';
  }
  if (isSingleDateSelection && isSameDate(selectionStart, dateString)) {
    return 'SingleDate';
  }
  if (enableSameDayDateRange && isSameDate(selectionStart, selectionEnd) && isSameDate(selectionStart, dateString)) {
    return 'StartAndEndSameDayEdge';
  }
  if (isSameDate(selectionStart, unconfirmedSelectionEnd) && isSameDate(unconfirmedSelectionEnd, dateString)) {
    return 'UnconfirmedStartAndEndSameDayEdge';
  }
  if (isSameDate(selectionStart, dateString)) {
    return 'StartRangeEdge';
  }
  if (isSameDate(selectionEnd, dateString)) {
    return 'EndRangeEdge';
  }
  if (isSameDate(unconfirmedSelectionEnd, dateString)) {
    if (selectionStart && unconfirmedSelectionEnd && isEarlierDate(selectionStart, unconfirmedSelectionEnd)) {
      return 'Unselected';
    }
    return 'UnconfirmedEndRangeEdge';
  }
  if (!isSingleDateSelection && isDateWithinRange(selectionStart, selectionEnd || unconfirmedSelectionEnd, dateString)) {
    if (dateUtils.isLastDayInMonth(day)) {
      return 'WithinRangeLastOfMonth';
    }
    if (dateUtils.isFirstDayInMonth(day)) {
      return 'WithinRangeFirstOfMonth';
    }
    return 'WithinRange';
  }
  return 'Unselected';
};
export { getSelectionType };